export const SIDEBAR_STORAGE_KEY = 'radar-vacation-dp-filters-collapsed';

import {
    ClockIcon,
    BanknotesIcon,
    ExclamationTriangleIcon,
    CalendarDaysIcon,
    ArchiveBoxXMarkIcon,
    BriefcaseIcon,
    PaperAirplaneIcon,
    CalendarIcon,
    DocumentIcon,
    CheckCircleIcon,
} from '@heroicons/react/24/outline';
import type { VacationDpFilterKey } from '../../models/vacationDpBoard.types';
import type { VacationCardMetadata, VacationFilterGroup } from './vacationFilterSidebar.types';
export {
    CARD_TONE_CLASSES,
    CARD_ICON_WRAP_CLASSES,
    CARD_LABEL_CLASSES,
    CARD_VALUE_CLASSES,
    CARD_ACTIVE_CLASSES,
    CARD_FOCUS_CLASSES,
} from '../shared/filterCardTones';

export const VACATION_CARD_METADATA: Record<VacationDpFilterKey, VacationCardMetadata> = {
    awaitingApproval: {
        label: 'Aprovação pendente',
        tone: 'primary',
        description: 'solicitações paradas no gestor ou no DP',
        group: 'action',
        icon: ClockIcon,
    },
    correctionPending: {
        label: 'Correção pendente',
        tone: 'warning',
        description: 'períodos em espera de correção pelo colaborador',
        group: 'action',
        icon: ExclamationTriangleIcon,
    },
    sellPending: {
        label: 'Abono pendente',
        tone: 'primary',
        description: 'pedidos de abono pecuniário ainda não decididos',
        group: 'action',
        icon: BanknotesIcon,
    },
    expired: {
        label: 'Vencidos',
        tone: 'danger',
        description: 'dias vencidos ou vencimento CLT já passado',
        group: 'risk',
        icon: ExclamationTriangleIcon,
    },
    expiring30: {
        label: 'A vencer em 30 dias',
        tone: 'warning',
        description: 'limite para agendar vencendo nos próximos 30 dias',
        group: 'risk',
        icon: CalendarDaysIcon,
    },
    noHistory: {
        label: 'Sem histórico',
        tone: 'warning',
        description: 'colaboradores elegíveis há 2+ anos sem férias lançadas no cadastro',
        group: 'risk',
        icon: ArchiveBoxXMarkIcon,
    },
    conflict: {
        label: 'Conflito c/ projeto',
        tone: 'warning',
        description: 'solicitações que colidem com uma alocação ativa',
        group: 'risk',
        icon: BriefcaseIcon,
    },
    onVacation: {
        label: 'Em Férias',
        tone: 'success',
        description: 'colaboradores de férias hoje',
        group: 'context',
        icon: PaperAirplaneIcon,
    },
    scheduled: {
        label: 'Agendadas',
        tone: 'info',
        description: 'colaboradores com férias aprovadas que ainda não começaram',
        group: 'context',
        icon: CalendarIcon,
    },
    vacationsCompleted: {
        label: 'Férias concluídas',
        tone: 'neutral',
        description: 'colaboradores que já retornaram de férias aprovadas',
        group: 'context',
        icon: CheckCircleIcon,
    },
    noRequest: {
        label: 'Sem solicitação',
        tone: 'neutral',
        description: 'colaboradores elegíveis que ainda não solicitaram férias',
        group: 'context',
        icon: DocumentIcon,
    },
};

export const DP_FILTER_GROUPS: readonly VacationFilterGroup[] = [
    {
        id: 'action',
        label: 'SOLICITAÇÕES',
        keys: ['awaitingApproval', 'correctionPending', 'sellPending', 'conflict'],
    },
    {
        id: 'risk',
        label: 'ALERTAS',
        keys: ['expired', 'expiring30', 'noHistory'],
    },
    {
        id: 'context',
        label: 'SITUAÇÃO',
        keys: ['onVacation', 'scheduled', 'vacationsCompleted', 'noRequest'],
    },
];

export const OVERLAP_HINT =
    'Um mesmo colaborador pode aparecer em mais de um cartão — a soma não corresponde ao total de colaboradores.';

export const ACTIVE_FILTER_HINT = 'Clique novamente no cartão para remover o filtro.';

export const GROUP_LABEL_CLASSES: Record<string, string> = {
    action: 'text-xs font-semibold font-montserrat text-raro-gray-700 uppercase tracking-widest',
    risk: 'text-xs font-semibold font-montserrat text-amber-700 uppercase tracking-widest',
    context: 'text-xs font-semibold font-montserrat text-raro-gray-500 uppercase tracking-widest',
};

export const GROUP_CONTAINER_CLASSES: Record<string, string> = {
    action: 'space-y-3',
    risk: 'space-y-3',
    context: 'space-y-3',
};
